import { NavLink } from 'react-router-dom';

export default function Nav() {
  return (
    <nav className="nav">
      <div className="nav__inner">
        <NavLink to="/" className="nav__name">Simone Ehrlich</NavLink>
        <ul className="nav__links">
          <li><NavLink to="/work" className={({ isActive }) => isActive ? 'active' : ''}>Work</NavLink></li>
          <li><NavLink to="/thinking" className={({ isActive }) => isActive ? 'active' : ''}>Thinking</NavLink></li>
          <li><NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''}>About</NavLink></li>
        </ul>
      </div>
    </nav>
  );
}
